"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBranchSchema = exports.createBranchSchema = exports.branchShape = void 0;
const zod_1 = require("zod");
exports.branchShape = {
    code: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string().min(1).max(255),
    parentBranchId: zod_1.z.string().uuid().optional(),
    timezone: zod_1.z.string().default('Asia/Kolkata'),
    addressLine1: zod_1.z.string().max(255).optional(),
    addressLine2: zod_1.z.string().max(255).optional(),
    city: zod_1.z.string().max(100).optional(),
    state: zod_1.z.string().max(100).optional(),
    country: zod_1.z.string().max(100).default('India'),
    postalCode: zod_1.z.string().max(20).optional(),
    status: zod_1.z.enum(['ACTIVE', 'INACTIVE']).default('ACTIVE'),
};
exports.createBranchSchema = zod_1.z.object(exports.branchShape);
exports.updateBranchSchema = exports.createBranchSchema.partial();
//# sourceMappingURL=branch.schema.js.map